import React, { useState, useRef } from 'react';

export default function App() {
  const [user, setUser] = useState(null);
  const [view, setView] = useState('login');
  const [form, setForm] = useState({});
  const [step, setStep] = useState(1);
  const [reqs, setReqs] = useState([
    { id:'REQ-001', vendor:'Salesforce', product:'CRM Platform', lob:'CIB', by:'john', byName:'John', date:'2026-01-10', purpose:'CRM for clients', data:['Customer Data'], value:'$250K-$1M', status:'Under Review',
      reviews:{ cyber:{s:'approved',r:'Mike Chen',c:'SOC2 compliant'}, legal:{s:'pending',r:null,c:null}, privacy:{s:'action_required',r:'Sarah Lee',c:'Need DPA'}, tech:{s:'approved',r:'Tom W',c:'OK'}, hr_duc:{s:'pending',r:null,c:null} },
      documents:[{name:'Salesforce_SOC2_Report.pdf',type:'SOC2 Report',uploadedBy:'John',uploadedAt:'2026-01-10'}] },
    { id:'REQ-002', vendor:'Workday', product:'HR Management System', lob:'HR', by:'john', byName:'John', date:'2026-01-08', purpose:'HR management', data:['Employee Data','PII'], value:'>$1M', status:'Approved',
      reviews:{ cyber:{s:'approved',r:'Mike',c:'OK'}, legal:{s:'approved',r:'Jane',c:'OK'}, privacy:{s:'approved',r:'Sarah',c:'DPA signed'}, tech:{s:'approved',r:'Tom',c:'OK'}, hr_duc:{s:'approved',r:'Lisa',c:'OK'} },
      documents:[{name:'Workday_DPA.pdf',type:'DPA',uploadedBy:'John',uploadedAt:'2026-01-08'}] },
    { id:'REQ-003', vendor:'Slack', product:'Communication Tool', lob:'Tech', by:'john', byName:'John', date:'2026-01-15', purpose:'Team collaboration', data:['Internal Comms'], value:'$50K-$250K', status:'Under Review',
      reviews:{ cyber:{s:'pending',r:null,c:null}, legal:{s:'pending',r:null,c:null}, privacy:{s:'not_required',r:null,c:null}, tech:{s:'pending',r:null,c:null}, hr_duc:{s:'not_required',r:null,c:null} },
      documents:[] },
    { id:'REQ-004', vendor:'Bloomberg', product:'Market Data Platform', lob:'CCB', by:'john', byName:'John', date:'2026-01-05', purpose:'Market data', data:['Financial Data'], value:'>$1M', status:'Declined',
      reviews:{ cyber:{s:'approved',r:'Mike',c:'OK'}, legal:{s:'declined',r:'Jane',c:'Terms unacceptable'}, privacy:{s:'approved',r:'Sarah',c:'OK'}, tech:{s:'approved',r:'Tom',c:'OK'}, hr_duc:{s:'not_required',r:null,c:null} },
      documents:[{name:'Bloomberg_Contract_Draft.pdf',type:'Contract',uploadedBy:'John',uploadedAt:'2026-01-05'}] },
  ]);

  const users = {
    'john':{name:'John',role:'requester',lob:'CIB',pw:'demo'},
    'cyber':{name:'Mike Chen',role:'reviewer',dept:'cyber',deptName:'Cyber Security',pw:'demo'},
    'legal':{name:'Jane Doe',role:'reviewer',dept:'legal',deptName:'Legal',pw:'demo'},
    'privacy':{name:'Sarah Lee',role:'reviewer',dept:'privacy',deptName:'Privacy',pw:'demo'},
    'tech':{name:'Tom Wilson',role:'reviewer',dept:'tech',deptName:'Technology',pw:'demo'},
    'hr_duc':{name:'Lisa Park',role:'reviewer',dept:'hr_duc',deptName:'HR DUC',pw:'demo'},
    'admin':{name:'Admin',role:'admin',pw:'demo'},
  };

  const vendorOptions = ['Salesforce', 'Workday', 'Microsoft', 'Oracle', 'SAP', 'ServiceNow', 'Slack', 'Zoom', 'Bloomberg', 'Reuters', 'AWS', 'Google Cloud', 'Adobe', 'Tableau', 'Snowflake', 'Dropbox', 'Box', 'DocuSign', 'Stripe', 'Other'];
  const productOptions = ['CRM Platform', 'HR Management System', 'ERP System', 'Communication Tool', 'Video Conferencing', 'Market Data Platform', 'Cloud Infrastructure', 'Analytics Platform', 'Data Warehouse', 'Document Management', 'Project Management', 'Security Software', 'Payment Processing', 'E-Signature Platform', 'File Storage', 'Other'];
  const lobOptions = ['CIB', 'CCB', 'HR', 'Tech', 'Legal', 'Finance', 'Operations', 'Risk'];

  const teams = [{k:'cyber',n:'Cyber'},{k:'legal',n:'Legal'},{k:'privacy',n:'Privacy'},{k:'tech',n:'Tech'},{k:'hr_duc',n:'HR DUC'}];
  const statusColors = { 'Under Review':'#F59E0B', 'Approved':'#10B981', 'Declined':'#EF4444', 'Action Required':'#3B82F6' };
  const revColors = { approved:'#10B981', pending:'#F59E0B', declined:'#EF4444', action_required:'#3B82F6', not_required:'#9CA3AF' };
  const revIcons = { approved:'✓', pending:'○', declined:'✗', action_required:'!', not_required:'—' };

  const appName = "Multi-LOB Data Use Coordination (DUC) Platform";

  // LOGIN COMPONENT
  function Login() {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [err, setErr] = useState('');

    const handleLogin = () => {
      const userObj = users[username];
      if (userObj && userObj.pw === password) {
        setUser({ id: username, ...userObj });
        if (userObj.role === 'requester') setView('req_dash');
        else if (userObj.role === 'reviewer') setView('rev_dash');
        else setView('admin');
      } else {
        setErr('Invalid credentials');
      }
    };

    return (
      <div style={{minHeight:'100vh',display:'flex',alignItems:'center',justifyContent:'center',background:'#0F172A',padding:20}}>
        <div style={{background:'#fff',borderRadius:16,padding:40,width:'100%',maxWidth:420}}>
          <div style={{textAlign:'center',marginBottom:32}}>
            <div style={{width:56,height:56,background:'linear-gradient(135deg,#3B82F6,#8B5CF6)',borderRadius:12,display:'inline-flex',alignItems:'center',justifyContent:'center',color:'#fff',fontWeight:700,fontSize:14,marginBottom:16}}>EM</div>
            <h1 style={{margin:'0 0 4px',fontSize:20,fontWeight:700,color:'#0F172A'}}>{appName}</h1>
          </div>
          <div style={{marginBottom:20}}>
            <label style={{display:'block',marginBottom:6,fontSize:14,fontWeight:500,color:'#334155'}}>Username</label>
            <input
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              style={{width:'100%',padding:'12px 16px',borderRadius:8,border:'1px solid #E2E8F0',fontSize:14,boxSizing:'border-box'}}
              placeholder="Enter username"
            />
          </div>
          <div style={{marginBottom:20}}>
            <label style={{display:'block',marginBottom:6,fontSize:14,fontWeight:500,color:'#334155'}}>Password</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              onKeyDown={(e) => e.key === 'Enter' && handleLogin()}
              style={{width:'100%',padding:'12px 16px',borderRadius:8,border:'1px solid #E2E8F0',fontSize:14,boxSizing:'border-box'}}
              placeholder="Enter password"
            />
          </div>
          {err && <p style={{color:'#EF4444',fontSize:14,marginBottom:16}}>{err}</p>}
          <button onClick={handleLogin} style={{width:'100%',padding:'12px 24px',background:'#3B82F6',color:'#fff',border:'none',borderRadius:8,fontSize:14,fontWeight:600,cursor:'pointer'}}>Sign In</button>
          <div style={{marginTop:24,padding:16,background:'#F8FAFC',borderRadius:8,fontSize:12,color:'#64748B'}}>
            <b>Demo Accounts (password: demo)</b><br/><br/>
            <b>Requester:</b> john<br/>
            <b>Reviewers:</b> cyber, legal, privacy, tech, hr_duc<br/>
            <b>Admin:</b> admin
          </div>
        </div>
      </div>
    );
  }

  // NAV COMPONENT
  function Nav() {
    return (
      <header style={{position:'fixed',top:0,left:0,right:0,height:64,background:'#0F172A',display:'flex',alignItems:'center',justifyContent:'space-between',padding:'0 24px',zIndex:100}}>
        <div style={{display:'flex',alignItems:'center',gap:12}}>
          <div style={{width:36,height:36,background:'linear-gradient(135deg,#3B82F6,#8B5CF6)',borderRadius:8,display:'flex',alignItems:'center',justifyContent:'center',color:'#fff',fontWeight:700,fontSize:11}}>EM</div>
          <div>
            <span style={{color:'#fff',fontWeight:600,fontSize:14,display:'block'}}>{appName}</span>
          </div>
        </div>
        <div style={{display:'flex',alignItems:'center',gap:16}}>
          <span style={{color:'#fff',fontSize:14,fontWeight:500}}>{user?.name}</span>
          <span style={{color:'#94A3B8',fontSize:12}}>{user?.role==='requester'?'Requester':user?.role==='reviewer'?user.deptName:'Admin'}</span>
          <button onClick={()=>{setUser(null);setView('login');}} style={{padding:'6px 12px',background:'transparent',border:'1px solid #475569',color:'#94A3B8',borderRadius:6,fontSize:12,cursor:'pointer'}}>Logout</button>
        </div>
      </header>
    );
  }

  // INTAKE FORM COMPONENT
  function Intake() {
    const [localForm, setLocalForm] = useState({...form});
    
    const updateField = (key, value) => {
      setLocalForm(prev => ({...prev, [key]: value}));
    };

    const toggleMulti = (key, value) => {
      setLocalForm(prev => {
        const current = prev[key] || [];
        if (current.includes(value)) {
          return {...prev, [key]: current.filter(v => v !== value)};
        } else {
          return {...prev, [key]: [...current, value]};
        }
      });
    };

    const goNext = () => {
      setForm(localForm);
      setStep(s => s + 1);
    };

    const goBack = () => {
      setForm(localForm);
      setStep(s => s - 1);
    };

    const handleSubmit = () => {
      const finalForm = localForm;
      const revs = {
        cyber: {s:'pending',r:null,c:null},
        legal: {s:'pending',r:null,c:null},
        privacy: {s: (finalForm.data||[]).some(d=>['Customer Data','Employee Data','PII'].includes(d)) ? 'pending' : 'not_required', r:null, c:null},
        tech: {s: finalForm.sysAccess==='Yes' ? 'pending' : 'not_required', r:null, c:null},
        hr_duc: {s: (finalForm.data||[]).includes('Employee Data') ? 'pending' : 'not_required', r:null, c:null}
      };
      const newReq = {
        id: `REQ-${String(reqs.length + 1).padStart(3,'0')}`,
        vendor: finalForm.vendor,
        product: finalForm.product,
        lob: finalForm.lob || user.lob,
        by: user.id,
        byName: user.name,
        date: new Date().toISOString().split('T')[0],
        purpose: finalForm.purpose,
        data: finalForm.data || [],
        value: finalForm.value,
        status: 'Under Review',
        reviews: revs,
        documents: []
      };
      setReqs(prev => [...prev, newReq]);
      setForm({});
      setLocalForm({});
      setStep(1);
      setView('success');
    };

    const totalSteps = 4;

    const inputStyle = {width:'100%',padding:'12px 16px',borderRadius:8,border:'1px solid #E2E8F0',fontSize:14,boxSizing:'border-box'};
    const labelStyle = {display:'block',marginBottom:6,fontSize:14,fontWeight:500,color:'#334155'};

    return (
      <div style={{minHeight:'100vh',background:'#F1F5F9',padding:'100px 20px 40px'}}>
        <div style={{background:'#fff',borderRadius:16,padding:32,maxWidth:640,margin:'0 auto'}}>
          <div style={{height:4,background:'#E2E8F0',borderRadius:2,marginBottom:8}}>
            <div style={{height:'100%',background:'#3B82F6',borderRadius:2,width:`${(step/totalSteps)*100}%`,transition:'width 0.3s'}}/>
          </div>
          <p style={{fontSize:12,color:'#64748B',marginBottom:24}}>Step {step} of {totalSteps}</p>

          {step === 1 && (
            <>
              <h2 style={{margin:'0 0 24px',fontSize:20,fontWeight:600,color:'#0F172A'}}>Vendor Information</h2>
              <div style={{display:'flex',flexDirection:'column',gap:20}}>
                <div>
                  <label style={labelStyle}>Vendor Name <span style={{color:'#EF4444'}}>*</span></label>
                  <select value={localForm.vendor||''} onChange={e=>updateField('vendor',e.target.value)} style={inputStyle}>
                    <option value="">Select vendor...</option>
                    {vendorOptions.map(v=><option key={v} value={v}>{v}</option>)}
                  </select>
                </div>
                <div>
                  <label style={labelStyle}>Product / Service <span style={{color:'#EF4444'}}>*</span></label>
                  <select value={localForm.product||''} onChange={e=>updateField('product',e.target.value)} style={inputStyle}>
                    <option value="">Select product/service...</option>
                    {productOptions.map(p=><option key={p} value={p}>{p}</option>)}
                  </select>
                </div>
                <div>
                  <label style={labelStyle}>Requesting LOB <span style={{color:'#EF4444'}}>*</span></label>
                  <select value={localForm.lob||''} onChange={e=>updateField('lob',e.target.value)} style={inputStyle}>
                    <option value="">Select LOB...</option>
                    {lobOptions.map(l=><option key={l} value={l}>{l}</option>)}
                  </select>
                </div>
              </div>
            </>
          )}

          {step === 2 && (
            <>
              <h2 style={{margin:'0 0 24px',fontSize:20,fontWeight:600,color:'#0F172A'}}>Business Justification</h2>
              <div style={{display:'flex',flexDirection:'column',gap:20}}>
                <div>
                  <label style={labelStyle}>Purpose / Business Need <span style={{color:'#EF4444'}}>*</span></label>
                  <textarea 
                    value={localForm.purpose||''} 
                    onChange={e=>updateField('purpose',e.target.value)} 
                    rows={4} 
                    style={{...inputStyle,fontFamily:'inherit',resize:'vertical'}} 
                    placeholder="Describe the business need..."
                  />
                </div>
                <div>
                  <label style={labelStyle}>Urgency Level <span style={{color:'#EF4444'}}>*</span></label>
                  <div style={{display:'flex',flexDirection:'column',gap:8}}>
                    {['Standard (4-6 weeks)','Expedited (2-3 weeks)','Critical (< 2 weeks)'].map(opt=>(
                      <label key={opt} style={{display:'flex',alignItems:'center',gap:8,fontSize:14,cursor:'pointer'}}>
                        <input type="radio" name="urgency" checked={localForm.urgency===opt} onChange={()=>updateField('urgency',opt)}/>
                        {opt}
                      </label>
                    ))}
                  </div>
                </div>
              </div>
            </>
          )}

          {step === 3 && (
            <>
              <h2 style={{margin:'0 0 24px',fontSize:20,fontWeight:600,color:'#0F172A'}}>Data & Access</h2>
              <div style={{display:'flex',flexDirection:'column',gap:20}}>
                <div>
                  <label style={labelStyle}>What data will vendor access? <span style={{color:'#EF4444'}}>*</span></label>
                  <div style={{display:'flex',flexWrap:'wrap',gap:8}}>
                    {['Customer Data','Employee Data','Financial Data','PII','Market Data','Internal Comms','Public Only'].map(opt=>(
                      <label key={opt} style={{display:'flex',alignItems:'center',gap:8,padding:'8px 12px',background:'#F8FAFC',borderRadius:6,fontSize:14,cursor:'pointer'}}>
                        <input type="checkbox" checked={(localForm.data||[]).includes(opt)} onChange={()=>toggleMulti('data',opt)}/>
                        {opt}
                      </label>
                    ))}
                  </div>
                </div>
                <div>
                  <label style={labelStyle}>Will vendor need system access? <span style={{color:'#EF4444'}}>*</span></label>
                  <div style={{display:'flex',flexDirection:'column',gap:8}}>
                    {['Yes','No'].map(opt=>(
                      <label key={opt} style={{display:'flex',alignItems:'center',gap:8,fontSize:14,cursor:'pointer'}}>
                        <input type="radio" name="sysAccess" checked={localForm.sysAccess===opt} onChange={()=>updateField('sysAccess',opt)}/>
                        {opt}
                      </label>
                    ))}
                  </div>
                </div>
              </div>
            </>
          )}

          {step === 4 && (
            <>
              <h2 style={{margin:'0 0 24px',fontSize:20,fontWeight:600,color:'#0F172A'}}>Contract Details</h2>
              <div style={{display:'flex',flexDirection:'column',gap:20}}>
                <div>
                  <label style={labelStyle}>Estimated Contract Value <span style={{color:'#EF4444'}}>*</span></label>
                  <select value={localForm.value||''} onChange={e=>updateField('value',e.target.value)} style={inputStyle}>
                    <option value="">Select value range...</option>
                    <option value="<$50K">Less than $50,000</option>
                    <option value="$50K-$250K">$50,000 - $250,000</option>
                    <option value="$250K-$1M">$250,000 - $1,000,000</option>
                    <option value=">$1M">More than $1,000,000</option>
                  </select>
                </div>
                <div>
                  <label style={labelStyle}>Target Go-Live Date <span style={{color:'#EF4444'}}>*</span></label>
                  <input type="date" value={localForm.targetDate||''} onChange={e=>updateField('targetDate',e.target.value)} style={inputStyle}/>
                </div>
              </div>
            </>
          )}

          <div style={{display:'flex',justifyContent:'space-between',marginTop:32,gap:12}}>
            {step > 1 && <button onClick={goBack} style={{padding:'12px 24px',background:'#F1F5F9',color:'#334155',border:'none',borderRadius:8,fontSize:14,fontWeight:500,cursor:'pointer'}}>← Back</button>}
            <div style={{flex:1}}/>
            {step < totalSteps ? (
              <button onClick={goNext} style={{padding:'12px 24px',background:'#3B82F6',color:'#fff',border:'none',borderRadius:8,fontSize:14,fontWeight:600,cursor:'pointer'}}>Next →</button>
            ) : (
              <button onClick={handleSubmit} style={{padding:'12px 24px',background:'#10B981',color:'#fff',border:'none',borderRadius:8,fontSize:14,fontWeight:600,cursor:'pointer'}}>Submit Request</button>
            )}
          </div>
        </div>
      </div>
    );
  }

  // SUCCESS COMPONENT
  function Success() {
    const r = reqs[reqs.length - 1];
    const pending = teams.filter(t => r?.reviews[t.k]?.s === 'pending').map(t => t.n);
    return (
      <div style={{minHeight:'100vh',background:'#F1F5F9',padding:'100px 20px',display:'flex',justifyContent:'center'}}>
        <div style={{background:'#fff',borderRadius:16,padding:40,maxWidth:500,textAlign:'center',height:'fit-content'}}>
          <div style={{width:64,height:64,background:'#D1FAE5',borderRadius:'50%',display:'inline-flex',alignItems:'center',justifyContent:'center',color:'#10B981',fontSize:28,marginBottom:16}}>✓</div>
          <h2 style={{margin:'0 0 8px',fontSize:24,fontWeight:600}}>Request Submitted!</h2>
          <p style={{color:'#64748B',marginBottom:24}}>Request ID: {r?.id}</p>
          <div style={{background:'#DBEAFE',borderRadius:12,padding:20,textAlign:'left',marginBottom:24}}>
            <h3 style={{margin:'0 0 12px',fontSize:16,fontWeight:600,color:'#1E40AF'}}>Reviews Required</h3>
            <div style={{display:'flex',gap:8,flexWrap:'wrap'}}>
              {pending.map(n=><span key={n} style={{padding:'6px 12px',background:'#3B82F6',color:'#fff',borderRadius:16,fontSize:12,fontWeight:500}}>{n}</span>)}
            </div>
          </div>
          <button onClick={()=>setView('req_dash')} style={{width:'100%',padding:'12px 24px',background:'#3B82F6',color:'#fff',border:'none',borderRadius:8,fontSize:14,fontWeight:600,cursor:'pointer'}}>Go to Dashboard</button>
        </div>
      </div>
    );
  }

  // REQUESTER DASHBOARD
  function ReqDash() {
    const my = reqs.filter(r => r.by === user.id);
    const [sel, setSel] = useState(null);
    const [uploadModal, setUploadModal] = useState(false);
    const [docType, setDocType] = useState('');
    const [toast, setToast] = useState('');
    const fileRef = useRef(null);

    const docTypes = ['SOC2 Report','Security Assessment','DPA','Contract Draft','Insurance Certificate','W-9','Technical Architecture','Privacy Assessment','Other'];

    const handleUpload = (e) => {
      const file = e.target.files[0];
      if (file && docType && sel) {
        const newDoc = {name: file.name, type: docType, uploadedBy: user.name, uploadedAt: new Date().toISOString().split('T')[0]};
        setReqs(p => p.map(r => r.id === sel.id ? {...r, documents: [...r.documents, newDoc]} : r));
        setSel(prev => ({...prev, documents: [...prev.documents, newDoc]}));
        setUploadModal(false);
        setDocType('');
        setToast('Document uploaded!');
        setTimeout(() => setToast(''), 3000);
        if (fileRef.current) fileRef.current.value = '';
      }
    };

    const deleteDoc = (docName) => {
      setReqs(p => p.map(r => r.id === sel.id ? {...r, documents: r.documents.filter(d => d.name !== docName)} : r));
      setSel(prev => ({...prev, documents: prev.documents.filter(d => d.name !== docName)}));
    };

    return (
      <div style={{minHeight:'100vh',background:'#F1F5F9',padding:'88px 24px 24px'}}>
        {toast && <div style={{position:'fixed',top:80,right:24,padding:'12px 20px',background:'#10B981',color:'#fff',borderRadius:8,fontSize:14,fontWeight:500,zIndex:200}}>✓ {toast}</div>}
        
        {uploadModal && (
          <div style={{position:'fixed',inset:0,background:'rgba(0,0,0,0.5)',display:'flex',alignItems:'center',justifyContent:'center',zIndex:300}}>
            <div style={{background:'#fff',borderRadius:16,padding:32,width:'100%',maxWidth:450}}>
              <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:24}}>
                <h2 style={{margin:0,fontSize:20,fontWeight:600}}>Upload Document</h2>
                <button onClick={()=>{setUploadModal(false);setDocType('');}} style={{background:'none',border:'none',fontSize:24,cursor:'pointer',color:'#64748B'}}>×</button>
              </div>
              <div style={{marginBottom:20}}>
                <label style={{display:'block',marginBottom:6,fontSize:14,fontWeight:500}}>Document Type *</label>
                <select value={docType} onChange={e=>setDocType(e.target.value)} style={{width:'100%',padding:'12px 16px',borderRadius:8,border:'1px solid #E2E8F0',fontSize:14,boxSizing:'border-box'}}>
                  <option value="">Select type...</option>
                  {docTypes.map(t=><option key={t} value={t}>{t}</option>)}
                </select>
              </div>
              <div style={{marginBottom:20}}>
                <label style={{display:'block',marginBottom:6,fontSize:14,fontWeight:500}}>Select File *</label>
                <input ref={fileRef} type="file" onChange={handleUpload} disabled={!docType} style={{width:'100%',padding:'12px',borderRadius:8,border:'2px dashed #E2E8F0',boxSizing:'border-box'}}/>
              </div>
              {!docType && <p style={{margin:0,fontSize:13,color:'#F59E0B',background:'#FEF3C7',padding:'12px',borderRadius:8}}>⚠️ Select document type first</p>}
            </div>
          </div>
        )}

        <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:24}}>
          <div>
            <h1 style={{margin:0,fontSize:24,fontWeight:700}}>My Vendor Requests</h1>
            <p style={{margin:'4px 0 0',color:'#64748B',fontSize:14}}>Requester Dashboard</p>
          </div>
          <button onClick={()=>{setStep(1);setForm({});setView('intake');}} style={{padding:'12px 24px',background:'#3B82F6',color:'#fff',border:'none',borderRadius:8,fontSize:14,fontWeight:600,cursor:'pointer'}}>+ New Request</button>
        </div>

        <div style={{display:'grid',gridTemplateColumns:'1fr 400px',gap:24}}>
          <div style={{display:'flex',flexDirection:'column',gap:12}}>
            {my.length === 0 ? (
              <div style={{background:'#fff',borderRadius:12,padding:40,textAlign:'center',color:'#64748B'}}>No requests yet. Click "+ New Request" to start.</div>
            ) : my.map(r => (
              <div key={r.id} onClick={()=>setSel(r)} style={{background:sel?.id===r.id?'#F0F9FF':'#fff',borderRadius:12,padding:20,cursor:'pointer',borderLeft:`4px solid ${statusColors[r.status]}`}}>
                <div style={{display:'flex',justifyContent:'space-between',marginBottom:12}}>
                  <span style={{fontSize:12,fontWeight:600,color:'#3B82F6'}}>{r.id}</span>
                  <span style={{padding:'4px 10px',borderRadius:12,fontSize:11,fontWeight:600,background:statusColors[r.status]+'22',color:statusColors[r.status]}}>{r.status}</span>
                </div>
                <h3 style={{margin:'0 0 4px',fontSize:16,fontWeight:600}}>{r.vendor}</h3>
                <p style={{margin:'0 0 12px',fontSize:13,color:'#64748B'}}>{r.product}</p>
                <div style={{display:'flex',gap:16,fontSize:12,color:'#64748B',marginBottom:12}}>
                  <span>📅 {r.date}</span>
                  <span>💰 {r.value}</span>
                  <span>📎 {r.documents?.length || 0} docs</span>
                </div>
                <div style={{display:'flex',gap:6}}>
                  {teams.map(t => {
                    const rv = r.reviews[t.k];
                    return <div key={t.k} style={{width:28,height:28,borderRadius:6,background:revColors[rv?.s]||'#E5E7EB',color:'#fff',display:'flex',alignItems:'center',justifyContent:'center',fontSize:11,fontWeight:600}} title={`${t.n}: ${rv?.s}`}>{revIcons[rv?.s]||'○'}</div>;
                  })}
                </div>
              </div>
            ))}
          </div>

          {sel && (
            <div style={{background:'#fff',borderRadius:12,padding:24,position:'sticky',top:88,maxHeight:'calc(100vh - 112px)',overflowY:'auto'}}>
              <h2 style={{margin:'0 0 4px',fontSize:18,fontWeight:600}}>{sel.vendor}</h2>
              <p style={{margin:'0 0 20px',fontSize:14,color:'#64748B'}}>{sel.product}</p>
              
              <div style={{marginBottom:20}}>
                <h3 style={{margin:'0 0 12px',fontSize:13,fontWeight:600,color:'#64748B',textTransform:'uppercase'}}>Details</h3>
                {[['Request ID',sel.id],['LOB',sel.lob],['Submitted',sel.date],['Value',sel.value],['Data',sel.data.join(', ')]].map(([l,v])=>(
                  <div key={l} style={{display:'flex',justifyContent:'space-between',padding:'8px 0',borderBottom:'1px solid #F1F5F9'}}>
                    <span style={{fontSize:13,color:'#64748B'}}>{l}</span>
                    <span style={{fontSize:13,fontWeight:500}}>{v}</span>
                  </div>
                ))}
              </div>

              <div style={{marginBottom:20}}>
                <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:12}}>
                  <h3 style={{margin:0,fontSize:13,fontWeight:600,color:'#64748B',textTransform:'uppercase'}}>Documents ({sel.documents?.length||0})</h3>
                  <button onClick={()=>setUploadModal(true)} style={{padding:'6px 12px',background:'#3B82F6',color:'#fff',border:'none',borderRadius:6,fontSize:12,fontWeight:600,cursor:'pointer'}}>+ Upload</button>
                </div>
                {(!sel.documents || sel.documents.length === 0) ? (
                  <div style={{padding:16,background:'#F8FAFC',borderRadius:8,textAlign:'center'}}>
                    <p style={{margin:0,fontSize:13,color:'#64748B'}}>No documents yet</p>
                  </div>
                ) : (
                  <div style={{display:'flex',flexDirection:'column',gap:8}}>
                    {sel.documents.map((doc,i) => (
                      <div key={i} style={{display:'flex',alignItems:'center',gap:10,padding:'10px 12px',background:'#F8FAFC',borderRadius:8}}>
                        <div style={{fontSize:18}}>📄</div>
                        <div style={{flex:1,minWidth:0}}>
                          <p style={{margin:0,fontSize:13,fontWeight:500,overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>{doc.name}</p>
                          <p style={{margin:0,fontSize:11,color:'#64748B'}}>{doc.type}</p>
                        </div>
                        <button onClick={()=>deleteDoc(doc.name)} style={{background:'none',border:'none',color:'#EF4444',cursor:'pointer',fontSize:14}}>🗑</button>
                      </div>
                    ))}
                  </div>
                )}
              </div>

              <div>
                <h3 style={{margin:'0 0 12px',fontSize:13,fontWeight:600,color:'#64748B',textTransform:'uppercase'}}>Review Status</h3>
                {teams.map(t => {
                  const rv = sel.reviews[t.k];
                  if (rv?.s === 'not_required') return null;
                  return (
                    <div key={t.k} style={{padding:'10px 0',borderBottom:'1px solid #F1F5F9'}}>
                      <div style={{display:'flex',justifyContent:'space-between'}}>
                        <span style={{fontSize:14,fontWeight:500}}>{t.n}</span>
                        <span style={{padding:'2px 8px',borderRadius:4,fontSize:11,fontWeight:600,background:revColors[rv?.s]+'22',color:revColors[rv?.s]}}>{rv?.s?.replace('_',' ')}</span>
                      </div>
                      {rv?.c && <p style={{margin:'4px 0 0',fontSize:12,color:'#64748B',fontStyle:'italic'}}>"{rv.c}"</p>}
                      {rv?.r && <p style={{margin:'2px 0 0',fontSize:11,color:'#94A3B8'}}>By {rv.r}</p>}
                    </div>
                  );
                })}
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }

  // REVIEWER DASHBOARD
  function RevDash() {
    const dept = user.dept;
    const pending = reqs.filter(r => r.reviews[dept]?.s === 'pending');
    const completed = reqs.filter(r => ['approved','declined','action_required'].includes(r.reviews[dept]?.s));
    const [sel, setSel] = useState(null);
    const [decision, setDecision] = useState('');
    const [comment, setComment] = useState('');
    const [toast, setToast] = useState('');

    const submitReview = () => {
      if (!sel || !decision) return;
      setReqs(prev => prev.map(r => {
        if (r.id !== sel.id) return r;
        const newRevs = {...r.reviews, [dept]: {s: decision, r: user.name, c: comment}};
        const allStatuses = Object.values(newRevs).map(x => x.s);
        let newStatus = 'Under Review';
        if (allStatuses.includes('declined')) newStatus = 'Declined';
        else if (allStatuses.every(s => s === 'approved' || s === 'not_required')) newStatus = 'Approved';
        else if (allStatuses.includes('action_required')) newStatus = 'Action Required';
        return {...r, reviews: newRevs, status: newStatus};
      }));
      setToast('Review submitted!');
      setTimeout(() => setToast(''), 3000);
      setSel(null);
      setDecision('');
      setComment('');
    };

    return (
      <div style={{minHeight:'100vh',background:'#F1F5F9',padding:'88px 24px 24px'}}>
        {toast && <div style={{position:'fixed',top:80,right:24,padding:'12px 20px',background:'#10B981',color:'#fff',borderRadius:8,fontSize:14,fontWeight:500,zIndex:200}}>✓ {toast}</div>}
        
        <div style={{marginBottom:24}}>
          <h1 style={{margin:0,fontSize:24,fontWeight:700}}>{user.deptName} Review Queue</h1>
          <p style={{margin:'4px 0 0',color:'#64748B',fontSize:14}}>{pending.length} pending reviews</p>
        </div>

        <div style={{display:'grid',gridTemplateColumns:'repeat(3,1fr)',gap:16,marginBottom:24}}>
          <div style={{background:'#fff',borderRadius:12,padding:20}}>
            <span style={{fontSize:32,fontWeight:700,color:'#F59E0B'}}>{pending.length}</span>
            <span style={{display:'block',fontSize:13,color:'#64748B',marginTop:4}}>Pending</span>
          </div>
          <div style={{background:'#fff',borderRadius:12,padding:20}}>
            <span style={{fontSize:32,fontWeight:700,color:'#10B981'}}>{completed.filter(r=>r.reviews[dept]?.s==='approved').length}</span>
            <span style={{display:'block',fontSize:13,color:'#64748B',marginTop:4}}>Approved</span>
          </div>
          <div style={{background:'#fff',borderRadius:12,padding:20}}>
            <span style={{fontSize:32,fontWeight:700,color:'#EF4444'}}>{completed.filter(r=>r.reviews[dept]?.s==='declined').length}</span>
            <span style={{display:'block',fontSize:13,color:'#64748B',marginTop:4}}>Declined</span>
          </div>
        </div>

        <div style={{display:'grid',gridTemplateColumns:'1fr 440px',gap:24}}>
          <div style={{display:'flex',flexDirection:'column',gap:12}}>
            {pending.length === 0 ? (
              <div style={{background:'#fff',borderRadius:12,padding:40,textAlign:'center',color:'#64748B'}}>🎉 All caught up! No pending reviews.</div>
            ) : pending.map(r => (
              <div key={r.id} onClick={()=>setSel(r)} style={{background:sel?.id===r.id?'#FEF3C7':'#fff',borderRadius:12,padding:20,cursor:'pointer',borderLeft:'4px solid #F59E0B'}}>
                <div style={{display:'flex',justifyContent:'space-between',marginBottom:12}}>
                  <span style={{fontSize:12,fontWeight:600,color:'#3B82F6'}}>{r.id}</span>
                  <span style={{padding:'4px 10px',borderRadius:12,fontSize:11,fontWeight:600,background:'#FEF3C7',color:'#92400E'}}>Pending Review</span>
                </div>
                <h3 style={{margin:'0 0 4px',fontSize:16,fontWeight:600}}>{r.vendor}</h3>
                <p style={{margin:'0 0 12px',fontSize:13,color:'#64748B'}}>{r.product}</p>
                <div style={{display:'flex',gap:16,fontSize:12,color:'#64748B'}}>
                  <span>🏢 {r.lob}</span>
                  <span>👤 {r.byName}</span>
                  <span>📎 {r.documents?.length||0} docs</span>
                </div>
              </div>
            ))}
          </div>

          {sel && (
            <div style={{background:'#fff',borderRadius:12,padding:24,position:'sticky',top:88,maxHeight:'calc(100vh - 112px)',overflowY:'auto'}}>
              <h2 style={{margin:'0 0 4px',fontSize:18,fontWeight:600}}>{sel.vendor}</h2>
              <p style={{margin:'0 0 20px',fontSize:14,color:'#64748B'}}>{sel.product}</p>

              <div style={{marginBottom:20}}>
                <h3 style={{margin:'0 0 12px',fontSize:13,fontWeight:600,color:'#64748B',textTransform:'uppercase'}}>Request Info</h3>
                {[['LOB',sel.lob],['Requested By',sel.byName],['Value',sel.value],['Data Types',sel.data.join(', ')]].map(([l,v])=>(
                  <div key={l} style={{display:'flex',justifyContent:'space-between',padding:'8px 0',borderBottom:'1px solid #F1F5F9'}}>
                    <span style={{fontSize:13,color:'#64748B'}}>{l}</span>
                    <span style={{fontSize:13,fontWeight:500}}>{v}</span>
                  </div>
                ))}
              </div>

              <div style={{marginBottom:20}}>
                <h3 style={{margin:'0 0 8px',fontSize:13,fontWeight:600,color:'#64748B',textTransform:'uppercase'}}>Purpose</h3>
                <p style={{margin:0,fontSize:13,color:'#334155'}}>{sel.purpose}</p>
              </div>

              <div style={{marginBottom:20}}>
                <h3 style={{margin:'0 0 12px',fontSize:13,fontWeight:600,color:'#64748B',textTransform:'uppercase'}}>Documents ({sel.documents?.length||0})</h3>
                {(!sel.documents || sel.documents.length === 0) ? (
                  <div style={{padding:12,background:'#FEF3C7',borderRadius:8,textAlign:'center'}}>
                    <p style={{margin:0,fontSize:13,color:'#92400E'}}>⚠️ No documents uploaded</p>
                  </div>
                ) : (
                  <div style={{display:'flex',flexDirection:'column',gap:8}}>
                    {sel.documents.map((doc,i) => (
                      <div key={i} style={{display:'flex',alignItems:'center',gap:10,padding:'10px 12px',background:'#F8FAFC',borderRadius:8}}>
                        <div style={{fontSize:18}}>📄</div>
                        <div style={{flex:1}}>
                          <p style={{margin:0,fontSize:13,fontWeight:500}}>{doc.name}</p>
                          <p style={{margin:0,fontSize:11,color:'#64748B'}}>{doc.type}</p>
                        </div>
                        <button style={{padding:'4px 8px',background:'#3B82F6',color:'#fff',border:'none',borderRadius:4,fontSize:11,cursor:'pointer'}}>View</button>
                      </div>
                    ))}
                  </div>
                )}
              </div>

              <div style={{borderTop:'1px solid #E2E8F0',paddingTop:20}}>
                <h3 style={{margin:'0 0 12px',fontSize:13,fontWeight:600,color:'#64748B',textTransform:'uppercase'}}>Your Decision</h3>
                <div style={{display:'flex',gap:8,marginBottom:16}}>
                  <button onClick={()=>setDecision('approved')} style={{flex:1,padding:10,border:'none',borderRadius:8,fontSize:13,fontWeight:600,cursor:'pointer',background:decision==='approved'?'#10B981':'#E5E7EB',color:decision==='approved'?'#fff':'#374151'}}>✓ Approve</button>
                  <button onClick={()=>setDecision('action_required')} style={{flex:1,padding:10,border:'none',borderRadius:8,fontSize:13,fontWeight:600,cursor:'pointer',background:decision==='action_required'?'#3B82F6':'#E5E7EB',color:decision==='action_required'?'#fff':'#374151'}}>! Action</button>
                  <button onClick={()=>setDecision('declined')} style={{flex:1,padding:10,border:'none',borderRadius:8,fontSize:13,fontWeight:600,cursor:'pointer',background:decision==='declined'?'#EF4444':'#E5E7EB',color:decision==='declined'?'#fff':'#374151'}}>✗ Decline</button>
                </div>
                <div style={{marginBottom:16}}>
                  <label style={{display:'block',marginBottom:6,fontSize:14,fontWeight:500}}>Comments</label>
                  <textarea 
                    value={comment} 
                    onChange={e=>setComment(e.target.value)} 
                    rows={3} 
                    style={{width:'100%',padding:'12px 16px',borderRadius:8,border:'1px solid #E2E8F0',fontSize:14,boxSizing:'border-box',fontFamily:'inherit'}} 
                    placeholder="Add review comments..."
                  />
                </div>
                <button onClick={submitReview} disabled={!decision} style={{width:'100%',padding:'12px 24px',background:decision?'#3B82F6':'#94A3B8',color:'#fff',border:'none',borderRadius:8,fontSize:14,fontWeight:600,cursor:decision?'pointer':'not-allowed'}}>Submit Review</button>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }

  // ADMIN DASHBOARD
  function Admin() {
    const [toast, setToast] = useState(false);
    const stats = {
      total: reqs.length,
      review: reqs.filter(r => r.status === 'Under Review').length,
      approved: reqs.filter(r => r.status === 'Approved').length,
      declined: reqs.filter(r => r.status === 'Declined').length
    };
    const byLOB = ['CIB','CCB','HR','Tech','Finance'].map(l => ({
      l,
      t: reqs.filter(r => r.lob === l).length
    })).filter(x => x.t > 0);

    const sendReminders = () => {
      setToast(true);
      setTimeout(() => setToast(false), 3000);
    };

    return (
      <div style={{minHeight:'100vh',background:'#F1F5F9',padding:'88px 24px 24px'}}>
        {toast && <div style={{position:'fixed',top:80,right:24,padding:'12px 20px',background:'#10B981',color:'#fff',borderRadius:8,fontSize:14,fontWeight:500,zIndex:200}}>✓ Reminders sent!</div>}
        
        <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:24}}>
          <div>
            <h1 style={{margin:0,fontSize:24,fontWeight:700}}>Admin Dashboard</h1>
            <p style={{margin:'4px 0 0',color:'#64748B',fontSize:14}}>Vendor Approval Overview</p>
          </div>
          <button onClick={sendReminders} style={{padding:'10px 20px',background:'#F59E0B',color:'#fff',border:'none',borderRadius:8,fontSize:14,fontWeight:600,cursor:'pointer'}}>🔔 Send Reminders</button>
        </div>

        <div style={{display:'grid',gridTemplateColumns:'repeat(4,1fr)',gap:16,marginBottom:24}}>
          <div style={{background:'#fff',borderRadius:12,padding:20}}>
            <span style={{fontSize:32,fontWeight:700}}>{stats.total}</span>
            <span style={{display:'block',fontSize:13,color:'#64748B',marginTop:4}}>Total Requests</span>
          </div>
          <div style={{background:'#fff',borderRadius:12,padding:20}}>
            <span style={{fontSize:32,fontWeight:700,color:'#F59E0B'}}>{stats.review}</span>
            <span style={{display:'block',fontSize:13,color:'#64748B',marginTop:4}}>Under Review</span>
          </div>
          <div style={{background:'#fff',borderRadius:12,padding:20}}>
            <span style={{fontSize:32,fontWeight:700,color:'#10B981'}}>{stats.approved}</span>
            <span style={{display:'block',fontSize:13,color:'#64748B',marginTop:4}}>Approved</span>
          </div>
          <div style={{background:'#fff',borderRadius:12,padding:20}}>
            <span style={{fontSize:32,fontWeight:700,color:'#EF4444'}}>{stats.declined}</span>
            <span style={{display:'block',fontSize:13,color:'#64748B',marginTop:4}}>Declined</span>
          </div>
        </div>

        <div style={{display:'grid',gridTemplateColumns:'2fr 1fr',gap:24}}>
          <div style={{background:'#fff',borderRadius:12,overflow:'hidden'}}>
            <div style={{padding:'16px 20px',borderBottom:'1px solid #E2E8F0'}}>
              <h3 style={{margin:0,fontSize:16,fontWeight:600}}>All Requests</h3>
            </div>
            <table style={{width:'100%',borderCollapse:'collapse'}}>
              <thead>
                <tr>
                  {['ID','Vendor','LOB','Cyber','Legal','Privacy','Tech','HR DUC','Status'].map(h => (
                    <th key={h} style={{padding:'12px 16px',textAlign:'left',fontSize:11,fontWeight:600,color:'#64748B',textTransform:'uppercase',background:'#F8FAFC'}}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {reqs.map(r => (
                  <tr key={r.id}>
                    <td style={{padding:'12px 16px',fontSize:13,borderBottom:'1px solid #F1F5F9'}}><span style={{color:'#3B82F6',fontWeight:600}}>{r.id}</span></td>
                    <td style={{padding:'12px 16px',fontSize:13,borderBottom:'1px solid #F1F5F9'}}>{r.vendor}</td>
                    <td style={{padding:'12px 16px',fontSize:13,borderBottom:'1px solid #F1F5F9'}}>{r.lob}</td>
                    {['cyber','legal','privacy','tech','hr_duc'].map(t => {
                      const rv = r.reviews[t];
                      return (
                        <td key={t} style={{padding:'12px 16px',borderBottom:'1px solid #F1F5F9'}}>
                          <span style={{display:'inline-flex',alignItems:'center',justifyContent:'center',width:24,height:24,borderRadius:4,background:revColors[rv?.s]||'#E5E7EB',color:'#fff',fontSize:11,fontWeight:600}}>{revIcons[rv?.s]||'○'}</span>
                        </td>
                      );
                    })}
                    <td style={{padding:'12px 16px',borderBottom:'1px solid #F1F5F9'}}>
                      <span style={{padding:'4px 10px',borderRadius:12,fontSize:11,fontWeight:600,background:statusColors[r.status]+'22',color:statusColors[r.status]}}>{r.status}</span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <div style={{display:'flex',flexDirection:'column',gap:16}}>
            <div style={{background:'#fff',borderRadius:12,padding:20}}>
              <h3 style={{margin:'0 0 16px',fontSize:14,fontWeight:600}}>Requests by LOB</h3>
              {byLOB.map(x => (
                <div key={x.l} style={{display:'flex',alignItems:'center',gap:12,marginBottom:12}}>
                  <span style={{width:50,fontSize:12,color:'#64748B'}}>{x.l}</span>
                  <div style={{flex:1,height:24,background:'#F1F5F9',borderRadius:4,overflow:'hidden'}}>
                    <div style={{height:'100%',background:'#3B82F6',borderRadius:4,width:`${(x.t/stats.total)*100}%`,display:'flex',alignItems:'center',justifyContent:'flex-end',paddingRight:8,fontSize:11,fontWeight:600,color:'#fff',minWidth:20}}>{x.t}</div>
                  </div>
                </div>
              ))}
            </div>
            <div style={{background:'#fff',borderRadius:12,padding:20}}>
              <h3 style={{margin:'0 0 16px',fontSize:14,fontWeight:600}}>Status Breakdown</h3>
              {[['Approved',stats.approved,'#10B981'],['Under Review',stats.review,'#F59E0B'],['Declined',stats.declined,'#EF4444']].map(([l,v,c]) => (
                <div key={l} style={{display:'flex',alignItems:'center',gap:12,marginBottom:12}}>
                  <span style={{width:80,fontSize:12,color:'#64748B'}}>{l}</span>
                  <div style={{flex:1,height:24,background:'#F1F5F9',borderRadius:4,overflow:'hidden'}}>
                    <div style={{height:'100%',background:c,borderRadius:4,width:stats.total?`${(v/stats.total)*100}%`:'0%',display:'flex',alignItems:'center',justifyContent:'flex-end',paddingRight:8,fontSize:11,fontWeight:600,color:'#fff',minWidth:v?20:0}}>{v}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div style={{fontFamily:"'Inter',-apple-system,sans-serif"}}>
      {view === 'login' && <Login />}
      {view !== 'login' && <Nav />}
      {view === 'intake' && <Intake />}
      {view === 'success' && <Success />}
      {view === 'req_dash' && <ReqDash />}
      {view === 'rev_dash' && <RevDash />}
      {view === 'admin' && <Admin />}
    </div>
  );
}
